<template>
  <v-dialog
    v-model="visible"
    width="600"
  >
    <v-card>
      <v-card-title>
        <span class="headline">Move Cases To New Case Group</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col class="text-body-1"> The selected cases will be moved to this case group. If the case group has a default assignee, new case reports will be assigned to the user. </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-alert
              class="text-body-1"
              type="info"
              >Existing case reports will not be reassigned to the new group's default assignee. Reassigning existing case reports can be done in Case Manager.
            </v-alert>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <p class="font-weight-bold text-body-1">Select a new case group or remove all cases from the case group below. </p>
            <v-select
              class="pt-2"
              v-model="selectedCaseGroup"
              :items="caseGroups"
              label="Case Group"
              item-text="name"
              item-value="id"
              return-object
              dense
              clearable
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          :color="!isUnlocked ? 'primary' : 'error'"
          @click="onRemove"
        >
          {{ !isUnlocked ? "Remove All From Case Group" : "Are You Sure?" }}
          <v-icon
            right
            v-if="isUnlocked"
            >mdi-lock-open</v-icon
          >
          <v-icon
            right
            v-else
            >mdi-lock</v-icon
          >
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click="closeDialog"
          >Cancel</v-btn
        >
        <v-btn
          color="primary"
          text
          @click="onConfirm"
        >
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "BulkCaseGroupSet",
  data() {
    return {
      selectedCaseGroup: {},
      isUnlocked: false,
    };
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
    caseGroups: {
      type: Array,
      required: true,
    },
  },
  methods: {
    onConfirm() {
      this.$emit("onConfirm", this.selectedCaseGroup);
    },
    onRemove() {
      if (!this.isUnlocked) {
        this.isUnlocked = true;
      } else {
        this.$emit("onConfirm", {id: "null"});
        setTimeout(() => {
          this.isUnlocked = false;
        }, 1000);
      }
    },
    closeDialog() {
      this.$emit("onClose");
    },
  },
};
</script>
